<template>
  <div v-if="hasCodebtor" class="columns">
    <div class="column">
      <!--      <b-tag-->
      <!--        type="is-primary is-light"-->
      <!--        class="mr-2 income-tag">-->
      <!--        Deudor-->
      <!--      </b-tag>-->
      <!--      <b-tag-->
      <!--        type="is-light"-->
      <!--        class="mr-2 income-tag">-->
      <!--        Codeudor-->
      <!--      </b-tag>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'CodebtorTag',
  props: {
    hasCodebtor: {
      type: Boolean,
      required: true
    }
  }
};
</script>

<style scoped>
.income-tag {
  width: 140px;
}
</style>
